import { ICachedCohortEntityBucket } from '../../redux/slices/cachedEntities';
import { RelationalOperatorKey } from '../apollo/graphqlSchema';

const parseRangeWithInfinityValue = (str: string) => str.replace(/[^\d.]/g, '');

const parseNumericRange = (str: string) => str.replace(/[^0-9,.]/g, '');

export const isRangeBucket = (str: string): boolean =>
  str.startsWith('[') && str.endsWith(')');

/**
 * Main goal of this function is
 * to parse bucket ranges [-∞, 2), or [2, 4), or [4, ∞) and provide
 * appropriate operator and values
 */
export const parseRangeBucket = (
  customRange: string,
): ICachedCohortEntityBucket | null => {
  if (!isRangeBucket(customRange)) {
    return null;
  }

  // [-∞, NUMBER) case
  if (customRange.startsWith('[-∞')) {
    const value = parseRangeWithInfinityValue(customRange);
    let operatorValue = +value;

    if (value.includes('.')) {
      operatorValue = +operatorValue.toFixed(2);
    }

    return {
      operator: RelationalOperatorKey.Lessthan,
      operatorValues: [operatorValue],
    };
  }

  // [NUMBER, ∞) case
  if (customRange.endsWith('∞)')) {
    const value = parseRangeWithInfinityValue(customRange);
    let operatorValue = +value;

    if (value.includes('.')) {
      operatorValue = +operatorValue.toFixed(2);
    }

    return {
      operator: RelationalOperatorKey.Greaterorequal,
      operatorValues: [operatorValue],
    };
  }

  // [NUMBER, NUMBER) case
  const [from, to] = parseNumericRange(customRange).split(',');

  // @Kostya: KB-6147
  // Between operator would make both from and to-values inclusive [from, to].
  // To correctly parse range, we are going to decrease to-value by 1
  let toValue = +to - 1;
  let fromValue = +from;

  // @jimmy: KB-7182
  // if either from or to value contains a decimal, parse it to a default precision 2
  if (to.includes('.')) {
    toValue = +(+to - 0.01).toFixed(2);
  }

  if (from.includes('.')) {
    fromValue = +fromValue.toFixed(2);
  }

  return {
    operator: RelationalOperatorKey.Between,
    operatorValues: [fromValue, toValue],
  };
};
